export default __webpack_public_path__ + "static/media/logicImmo.f0c49043.svg";